






import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

const importAll = (requireContext: __WebpackModuleApi.RequireContext) =>
  requireContext.keys().forEach(requireContext);
try {
  importAll(require.context("../assets/icons", true, /\.svg$/));
} catch (error) {
  console.log(error);
}

@Component
export default class Icon extends Vue {
  @Prop(String) readonly name: string | undefined;
}
